import { Alert } from "antd";
import {useServerStatus} from "../../hooks/useServerStatus";
import {useAuth0} from "@auth0/auth0-react";

export function OfflineBanner() {
    const auth = useAuth0();
    const isOnline = useServerStatus(5000);

    if (auth.isLoading || !auth.isAuthenticated || isOnline) return null;

    return <div style={{ zIndex: 9999 }}>
            <Alert
                message="Jesteś offline. Niektóre funkcje mogą być niedostępne."
                type="warning"
                showIcon
                banner
            />
        </div>
}
